import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import "../styles/NewChatPage.css";

import { initSession, loadSession } from "../utils/sessionManager";
import { NewChatPageProps } from "../api/types";
import { getRouteIdentifier } from "../utils/chatPage";
import { PublicIdCode } from "../utils/publicIdCode";

import EditableVisibleName from "../components/EditableVisibleName";
import ChatInput from "../components/ChatInput";
import AppPrompt from "../components/AppPrompt";
import ChatMessages from "../components/ChatMessages";

import NewChatPageReady from "./NewChatPageReady";

const NewChatPage: React.FC<NewChatPageProps> = ({ mode }) => {
  const { chatNumber } = useParams<{ chatNumber: string }>();
  const { publicId } = useParams<{ publicId: string }>();

  const resolved = useMemo(() => {
    if (
      mode === "chatNumber" &&
      chatNumber &&
      PublicIdCode.isEncodedPublicId(chatNumber)
    ) {
      console.log("Encoded public id detected on /connect route:", chatNumber);

      return {
        mode: "publicId" as const,
        chatNumber: undefined,
        publicId: chatNumber,
        originalConnectValue: chatNumber,
      };
    }

    return {
      mode,
      chatNumber,
      publicId,
      originalConnectValue: chatNumber ?? publicId,
    };
  }, [mode, chatNumber, publicId]);

  const identifier = useMemo(
    () =>
      getRouteIdentifier(
        resolved.mode,
        resolved.chatNumber,
        resolved.publicId,
      ),
    [resolved.mode, resolved.chatNumber, resolved.publicId],
  );

  const [sessionReady, setSessionReady] = useState(false);
  const [sessionError, setSessionError] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const bootstrap = async () => {
      try {
        const existing = loadSession();

        if (existing?.userName && existing?.requestToken) {
          if (!cancelled) setSessionReady(true);
          return;
        }

        await initSession();

        if (!cancelled) setSessionReady(true);
      } catch (error) {
        console.error("Failed to initialize session", error);
        if (!cancelled) setSessionError(true);
      }
    };

    bootstrap();

    return () => {
      cancelled = true;
    };
  }, [identifier]);

  if (sessionError) {
    return (
      <div className="chat-container">
        <h2 className="chat-header">
          Chat with <span className="chat-username">...</span>
        </h2>

        <div style={{ marginBottom: 16 }}>
          Error: Session expired or missing. Please scan the QR code again.
        </div>

        <ChatMessages messages={[]} messagesEndRef={{ current: null }} otherUserTyping={false} />

        <ChatInput
          value=""
          isChatReady={false}
          onChange={() => {}}
          onSend={() => {}}
        />
      </div>
    );
  }

  if (!sessionReady) {
    return (
      <div className="chat-container">
        <h2 className="chat-header">
          Chat with <span className="chat-username">...</span>
        </h2>



        <ChatMessages messages={[]} messagesEndRef={{ current: null }} otherUserTyping={false} />

        <ChatInput
          value=""
          isChatReady={false}
          onChange={() => {}}
          onSend={() => {}}
        />

      </div>
    );
  }

  return (
    <NewChatPageReady
      mode={resolved.mode}
      chatNumber={resolved.chatNumber}
      publicId={resolved.publicId}
      originalConnectValue={resolved.originalConnectValue}
    />
  );
};

export default NewChatPage;